import React from 'react';
import {Box, Grid, Typography} from '@mui/material';

export default function officeColumn() {
    return {
        name: 'nameFilter',
        setBodyRowProps: () => ({ sx: { p: 0, backgroundColor: 'primary.main' } }),
        setBodyCellProps: () => ({
            sx: {
                verticalAlign: 'top',
                p: 1,
                pl: 2,
                backgroundColor: 'primary.main',
                border: 0,
                userSelect: 'none',
                cursor: 'default',
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '150 !important',
            },
        }),
        render: office => <Grid container>
            <Grid
                item
                xs={6}
                sx={{
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'center',
                    color: 'secondary.contrastText',
                }}
            >
                <Box sx={{ width: '100%' }}>
                    <Typography  sx={{ textAlign: 'left' }} variant="subtitle1" fontWeight={600}>
                        {office}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    };
}
